export default {
    email: 'E-mail address',
    phone: 'Phone number',
    cellphone: 'Mobile phone number',
    virtual_account: 'Username for the video event',
    reacts_event_url: 'Link to the video event',
    reacts_event_id: 'Video event number',
    resident_room_number: 'If known, room number of the person to contact',
    ah635_health_problems_question: 'Current Health Problems',
    ah635_immunosuppression_question: 'Immunosuppression',
    ah635_allergic_reactions_question: 'Allergic Reactions',
    ah635_pregnancy_question: 'Pregnancy',
    ah635_bleeding_disorder_question: 'Bleeding Disorder',
    ah635_immunization_question: 'Immunization or Blood Products',
    influenza_health_status: 'Do any of the following apply to you?',
    influenza_is_immunosuppressive: 'Does one of the following situation apply to you?',
    influenza_has_severe_reaction: 'Have you ever had a severe reaction after receiving a vaccine or other product that required a hospital visit?',
    influenza_is_pregnant: 'If you are a woman, are you currently pregnant?',
    influenza_received_vaccine_last_month: 'Have you received a vaccine during the last month?',
    influenza_has_immunocompromised_contact: 'Are you in close contact with an immunocompromised person?',
    influenza_people_who_live_with_me: 'Do you live with an infant under 6 months of age, a person 75 years of age or older, a pregnant woman in her 2nd or 3rd trimester, or a person with a chronic illness?',
    influenza_has_blood_transfusion: 'Have you received a blood transfusion or immunoglobulin in the past 11 months?',
    influenza_received_pneumococcal_vaccine: 'Have you received a Pneumococcal vaccine in the past?',
    influenza_is_health_care_worker: 'Are you a health care worker?',
    influenza_received_shingles_vaccine: 'Have you received a Shingles vaccine in the past?',
    phx_covid_screening_reason: 'COVID-19 screening reason',
    phx_covid_screening_details_consent: 'I consent to the details of the COVID-19 screening test',
    phx_covid_screening_consent: 'I consent to the COVID-19 screening test',
    phx_covid_accept_risk: 'By checking this box, I acknowledge to have read and understood the information and accept the limitations and risks associated with the rapid screening.',
    covid_screening_student_level: 'Educational level',
    as624_health_problems_question: 'Current health problems',
    as624_immunosuppression_question: 'Immunosuppression',
    as624_allergic_reactions_question: 'Allergic reactions',
    as624_bleeding_disorder_question: 'Bleeding disorder',
    as624_has_blood_transfusion_question: 'Blood transfusion or immunoglobulin injection',
    as624_pregnancy_question: 'Pregnancy',
    as624_less_than_six_months_mother_treatment_question: 'Patient less than six months mother treatment during pregnancy',
    phone_extension: 'Phone extension',
    sendConfirmationSms: 'Send Confirmation SMS',
    confirmEmail: 'Confirm Email',
    traveler_ramq: 'Traveler RAMQ',
    traveler_birthdate: 'Traveler birthdate',
    travel_departure_date: 'Travel departure date',
    traveler_first_name: 'Traveler\'s first name',
    traveler_last_name: 'Traveler\'s last name',
    traveler_age: 'Traveler\'s age',
    traveler_status: 'Traveler\'s status',
    recaptcha: 'I am not a robot',
    terms_agreement: 'Terms and conditions',
    privacy_policy_agreement: 'Privacy policy',
    'nam-expiration-date': 'Expiration date of the health insurance card',
    'nam-sequential': 'Sequential number of the health insurance card',
};
